import { MapOptions } from '@bpd-library/types';
import { Actions, createLocalStorageStore } from '@bpd-library/utilities';

export type ThemeClass =
    | 't-theme-sustainable'
    | 't-theme-classic'
    | 't-theme-modern'
    | 't-theme-raw'
    | 't-theme-urban';

export interface DebuggerState {
    showDictionaryKeys?: boolean;
    showBackendDictionaryKeys?: boolean;
    selectedTheme?: ThemeClass;
    propertiesId: boolean;
    showObjectTypeInMap?: boolean;
    showIdInMap?: boolean;
    showIdInHouseSelector?: boolean;
}

type DebuggerStoreActions =
    | 'init'
    | 'toggleDictionaryKeys'
    | 'toggleBackendDictionaryKeys'
    | 'selectTheme'
    | 'togglePropertiesId'
    | 'toggleObjectTypeInMap'
    | 'toggleIdInMap'
    | 'toggleIdInHouseSelector'
    | 'resetState';

const initialState: DebuggerState = {
    showDictionaryKeys: false,
    showBackendDictionaryKeys: false,
    selectedTheme: undefined,
    propertiesId: false,
    showObjectTypeInMap: false,
    showIdInMap: false,
    showIdInHouseSelector: false,
};

const originalState = Object.assign({}, initialState);

const actions: Actions<DebuggerStoreActions, DebuggerState> = {
    init: (state: DebuggerState, payload: DebuggerState) => {
        if (payload) {
            return Object.assign(state, payload);
        }

        return state;
    },
    toggleDictionaryKeys: (state: DebuggerState) => {
        state.showDictionaryKeys = !state.showDictionaryKeys;
        return state;
    },
    toggleBackendDictionaryKeys: (state: DebuggerState) => {
        state.showBackendDictionaryKeys = !state.showBackendDictionaryKeys;
        return state;
    },
    selectTheme: (state: DebuggerState, payload: ThemeClass) => {
        state.selectedTheme = payload;
        return state;
    },
    togglePropertiesId: (state: DebuggerState) => {
        state.propertiesId = !state.propertiesId;
        return state;
    },
    toggleObjectTypeInMap: (state: DebuggerState) => {
        state.showObjectTypeInMap = !state.showObjectTypeInMap;
        return state;
    },
    toggleIdInMap: (state: DebuggerState) => {
        state.showIdInMap = !state.showIdInMap;
        return state;
    },
    toggleIdInHouseSelector: (state: DebuggerState) => {
        state.showIdInHouseSelector = !state.showIdInHouseSelector;
        return state;
    },
    resetState: (state: DebuggerState) => {
        return Object.assign(state, originalState);
    },
};

export const toggleDictionaryKeys = () => {
    debugStore.dispatch('toggleDictionaryKeys');
};

export const toggleBackendDictionaryKeys = () => {
    debugStore.dispatch('toggleBackendDictionaryKeys');
};

export const togglePropertiesId = () => {
    debugStore.dispatch('togglePropertiesId');
};

export const storeTheme = (payload: ThemeClass) => {
    debugStore.dispatch('selectTheme', payload);
};

export const getDebugState = () => {
    return debugStore.getState();
};

export const toggleObjectTypeInMap = () => {
    debugStore.dispatch('toggleObjectTypeInMap');
};

export const toggleIdInMap = () => {
    debugStore.dispatch('toggleIdInMap');
};

export const toggleIdInHouseSelector = () => {
    debugStore.dispatch('toggleIdInHouseSelector');
};

export const resetState = () => {
    debugStore.dispatch('resetState');
};

export const getDebuggerMapOptions = (): Pick<MapOptions, 'debugMode' | 'debugProperties'> => {
    const state = debugStore.getState();
    const debugMode = state.showObjectTypeInMap || state.showIdInMap;

    let debugProperties: undefined | MapOptions['debugProperties'];

    if (debugMode) {
        debugProperties = [];

        if (state.showIdInMap) debugProperties.push('id');
        if (state.showObjectTypeInMap) debugProperties.push('objectType');

        return {
            debugMode: Boolean(debugMode),
            debugProperties,
        };
    }

    return {};
};

export const debugStore = createLocalStorageStore({
    key: 'debugStore',
    initialState,
    actions,
    initAction: 'init',
});
